import React, { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

export default function Form16Section() {
  const [docs,    setDocs]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    fetch(`${API_BASE}/api/payroll/form16`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => setDocs(Array.isArray(d) ? d : []))
      .catch(() => setDocs([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Form 16 · Tax Documents</span>
      </div>

      <div className="p-4 space-y-2">
        {loading ? (
          Array.from({ length: 2 }).map((_, i) => <div key={i} className="h-11 rounded-lg bg-white/5 animate-pulse" />)
        ) : docs.length === 0 ? (
          <p className="text-white/20 text-sm italic py-4 text-center">No Form 16 documents available yet.</p>
        ) : (
          docs.map(doc => (
            <div key={doc.year} className="flex items-center justify-between gap-3 rounded-lg border border-white/5 bg-white/3 px-4 py-2.5">
              <div className="flex items-center gap-2">
                <FileText size={14} className="text-[#00ff90]/40 shrink-0" />
                <span className="text-sm text-white/70">Form 16 · {doc.year}</span>
              </div>
              <a href={doc.url} download
                className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                <Download size={11} /> Download
              </a>
            </div>
          ))
        )}
      </div>
    </div>
  );
}